import { registerOverlaySubview } from '@neptune/project-domain';
import { ProjectSettingsContainer } from '@neptune/project-feature';

registerOverlaySubview({
  label: 'Settings',
  icon: 'cog',
  id: 'project-settings',
  Component: ProjectSettingsContainer,
});
